import { EIsOpen, EOrderSide, ETypeClient } from "../../../interfaces/IQuery";
import { convertToHourAndDate } from "../../../utils/date";

const optionsTwo = [
  { label: "operacoes.mock.all", value: EIsOpen.ALL },
  {
    label: "operacoes.mock.open_positions",
    value: EIsOpen.TRUE,
  },
  {
    label: "operacoes.mock.closed_positions",
    value: EIsOpen.FALSE,
  },
];

const optionsTree = [
  { label: "operacoes.mock.all", value: EOrderSide.ALL },
  { label: "operacoes.mock.buy", value: EOrderSide.BUY },
  { label: "operacoes.mock.sell", value: EOrderSide.SELL },
];

const OPTIONS_TYPE_CLIENT = [
  {
    label: "operacoes.mock.cpf",
    value: ETypeClient.document_nr,
  },
  {
    label: "operacoes.mock.email",
    value: ETypeClient.email,
  },
  { label: "operacoes.mock.name", value: ETypeClient.name },
];

const MOCK_PRODUTOS = [
  { label: "operacoes.mock.all_products", value: "" },
  { label: "Produto 1", value: "1" },
  { label: "Produto 2", value: "2" },
  { label: "Produto 3", value: "3" },
];
interface ITranslatable {
  translationKey: string;
  hourAndDate?: string;
}
const formatLastUpdated = (lastUpdated: any): ITranslatable => {
  if (!lastUpdated || isNaN(new Date(lastUpdated).getTime())) {
    return { translationKey: "operacoes.mock.invalid_date" };
  }
  const hourAndDate = convertToHourAndDate(lastUpdated);

  return {
    translationKey: "operacoes.mock.updated_at",
    hourAndDate: `${hourAndDate}`,
  };
};

export {
  optionsTree,
  optionsTwo,
  MOCK_PRODUTOS,
  formatLastUpdated,
  OPTIONS_TYPE_CLIENT,
};
